import type { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantRefService } from '@shared/services/tenant-ref.service';

export const tenantRefInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const tenantRefService = inject(TenantRefService);

  const tenantRef = tenantRefService.getTenantRef();

  if (!tenantRef) {
    return next(req);
  }

  const authReq = req.clone({
    headers: req.headers.set('x-tenant-ref', tenantRef),
  });

  return next(authReq);
};
